import { portalURL } from '@/helpers/environmentHelper';
import { useAppSelector } from '@/state/hooks';
import { User } from '@/state/reducers/authSlice';
import { selectNotificationSettings } from '@/state/reducers/settingSlice';
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSso } from '../providers/SSOProvider';
import { parseNotificationSettings, toastError } from './useToast';

// interface UseXplorPortalProps {
//     credentials: User;
// }

interface UseXplorPortalReturn {
    onXplorPortal: () => void;
}

const useXplorPortal = (credentials?: User): UseXplorPortalReturn => {
    const { jwt } = useSso();
    const navigate = useNavigate();

    const notifications = useAppSelector(selectNotificationSettings);

    const onXplorPortal = useCallback(async () => {
        try {
            if (portalURL) {
                if (jwt) navigate(`/portal`);
                else alert('You were not authorize via SSO to access the portal.');
            }
        } catch (e) {
            const toastConfig = parseNotificationSettings(notifications);
            {
                /* TBA - Translations */
            }
            toastError({
                body: (
                    <div>
                        <p>Please try again or contact support.</p>
                    </div>
                ),
                title: 'Failed to direct user to the Client Portal',
                persist: true,
                toastConfig
            });
        }
    }, [credentials?.authToken, jwt]);

    return { onXplorPortal };
};

export default useXplorPortal;
